/**
 * Leave the app for another site (e.g. Google sign-in) in the same tab.
 * Its own module so tests can stub it — jsdom can't navigate away.
 */
export const redirectTo = (url) => {
  window.location.assign(url);
};
